<template>
    <div class="slider2" >
            <vue-flux 
                 class= "custome-slide"
                :options="vfOptions"
                :transitions="vfTransitions"
                :images="vfImages"
                :captions="vfCaptions">
          </vue-flux>
   </div>
</template>
<script>
import LinkImage from "@/components/Constants/LinkImage.js"
import {
   VueFlux
} from 'vue-flux';
export default {
    name:"slider2",
    components: {
      VueFlux
   },
    data(){
        return{
      vfOptions: {
         autoplay: true
      },
      vfImages: [ 
            LinkImage.vanchuyenmaiphuong1,
            LinkImage.vanchuyenmaiphuong2,
            LinkImage.vanchuyenmaiphuong3, 
            ],
      vfTransitions: [ 'fade', 'cube', 'book' ],
      vfCaptions: [
         'Caption for image 1',
         'Caption for image 2',
         'Caption for image 3',
      ],
    }
    },
   created(){
   }
}
</script>
<style scoped>
.slider2{
    width: 65%;
    z-index: 1 !important;
    position: static;
    margin: 0 auto;
    padding-top:10px ;
    padding-bottom:10px ;
}
.vue-flux .custome-slide {
   z-index: 1 !important;
}
div .complements {
   color:red;
}
</style>